import React from 'react';
//import axiosClient from '../../api/axiosClient';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 1. Log to Console
    console.error("Uncaught Frontend Error:", error, errorInfo);

    // 2. Send to Backend Blackbox
    // Use raw fetch to avoid axios interceptor loops if axios itself is broken
    try {
        fetch('https://api.airssecurity.com/api/v1/agents/frontend/report_error', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                message: error.toString(),
                trace: errorInfo.componentStack,
                source: 'frontend_client'
            })
        });
    } catch (e) {
        console.error("Failed to report error", e);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen flex items-center justify-center bg-slate-900 text-white text-center p-10">
          <div>
            <h1 className="text-3xl font-bold text-red-500 mb-4">System UI Critical Failure</h1>
            <p className="text-slate-400 mb-6">An automated report has been sent to the Command Center.</p>
            <button onClick={() => window.location.reload()} className="bg-blue-600 px-6 py-2 rounded-lg font-bold">
                Reboot Interface
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default GlobalErrorBoundary;